<div class="grid p-3">
    <!-- KPIs Row 1 -->
    <div class="col-12 md:col-6 lg:col-3">
        <div class="surface-card shadow-2 p-3 border-round cursor-pointer hover:surface-100 transition-all transition-duration-200" 
             (click)="selectTab(3)">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-500 font-medium mb-2">Total Artículos</span>
                    @if (loadingItems()) {
                        <p-skeleton width="3rem" height="2rem" />
                    } @else {
                        <div class="text-900 font-bold text-2xl">{{ totalItems() }}</div>
                    }
                </div>
                <div class="flex align-items-center justify-content-center bg-blue-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                    <i class="pi pi-box text-blue-500 text-xl" style="line-height: 0"></i>
                </div>
            </div>
            <div class="flex align-items-center justify-content-between">
                <span class="text-500 font-medium text-xs">Catálogo registrado</span>
                <i class="pi pi-info-circle text-400 text-xs cursor-pointer" pTooltip="Cantidad total de ítems dados de alta en el sistema (reactivos, consumibles, estándares, etc.)." tooltipPosition="top"></i>
            </div>
        </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
        <div class="surface-card shadow-2 p-3 border-round">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-500 font-medium mb-2">Valor de Inventario</span>
                    @if (loadingItems()) {
                        <p-skeleton width="6rem" height="2rem" />
                    } @else if (totalValue().length > 0) {
                        <div class="flex flex-column gap-1">
                            @for (val of totalValue(); track val.currency) {
                                <div class="flex align-items-baseline gap-2">
                                    <span class="text-xs font-semibold text-600 bg-gray-100 px-2 py-0 border-round">{{ val.currency || 'ARS' }}</span>
                                    <span class="text-900 font-bold text-xl">{{ formatCurrencyValue(val.value, val.currency) }}</span>
                                </div>
                            }
                        </div>
                    } @else {
                        <div class="text-900 font-bold text-2xl">$ 0,00</div>
                    }
                </div>
                <div class="flex align-items-center justify-content-center bg-green-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                    <i class="pi pi-money-bill text-green-500 text-xl" style="line-height: 0"></i>
                </div>
            </div>
            <div class="flex align-items-center justify-content-between">
                <span class="text-green-600 font-medium text-xs">Capital total en stock</span>
                <i class="pi pi-info-circle text-400 text-xs cursor-pointer" pTooltip="Calculado según el precio unitario registrado para cada ítem con stock disponible (Suma de Stock * Precio)." tooltipPosition="top"></i>
            </div>
        </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
        <div class="surface-card shadow-2 p-3 border-round cursor-pointer hover:surface-100 transition-all transition-duration-200" 
             [class.border-left-3]="activeTab() === 0" [class.border-red-500]="activeTab() === 0"
             (click)="selectTab(0)">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-500 font-medium mb-2">Stock Bajo</span>
                    @if (loadingItems()) {
                        <p-skeleton width="3rem" height="2rem" />
                    } @else {
                        <div class="text-900 font-bold text-2xl text-red-600">{{ lowStock() }}</div>
                    }
                </div>
                <div class="flex align-items-center justify-content-center bg-red-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                    <i class="pi pi-exclamation-circle text-red-500 text-xl" style="line-height: 0"></i>
                </div>
            </div>
            <div class="flex align-items-center justify-content-between">
                <span class="text-red-500 font-medium text-xs">Stock &lt; Punto Mínimo</span>
                <i class="pi pi-info-circle text-400 text-xs cursor-pointer" pTooltip="Artículos con riesgo inminente de quiebre (Stock < Mínimo). Requieren reabastecimiento urgente." tooltipPosition="top"></i>
            </div>
        </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
        <div class="surface-card shadow-2 p-3 border-round cursor-pointer hover:surface-100 transition-all transition-duration-200" 
             (click)="selectTab(0)">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-500 font-medium mb-2">Alertas de Stock</span>
                    @if (loadingItems()) {
                        <p-skeleton width="3rem" height="2rem" />
                    } @else {
                        <div class="text-900 font-bold text-2xl text-orange-600">{{ alertStock() }}</div>
                    }
                </div>
                <div class="flex align-items-center justify-content-center bg-orange-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                    <i class="pi pi-bell text-orange-500 text-xl" style="line-height: 0"></i>
                </div>
            </div>
            <div class="flex align-items-center justify-content-between">
                <span class="text-orange-500 font-medium text-xs">Punto de pedido preventivo</span>
                <i class="pi pi-info-circle text-400 text-xs cursor-pointer" pTooltip="Nivel de alerta temprana (Stock <= Alerta) para iniciar gestiones de compra antes de llegar al mínimo." tooltipPosition="top"></i>
            </div>
        </div>
    </div>

    <!-- KPIs Row 2 (Interactive) -->
    <div class="col-12 md:col-6 lg:col-3">
        <div class="surface-card shadow-2 p-3 border-round cursor-pointer hover:surface-100 transition-all transition-duration-200"
             [class.border-left-3]="activeTab() === 2" [class.border-red-500]="activeTab() === 2"
             (click)="selectTab(2)">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-500 font-medium mb-2">Artículos Vencidos</span>
                    @if (loadingItems()) {
                        <p-skeleton width="3rem" height="2rem" />
                    } @else {
                        <div class="text-900 font-bold text-2xl text-red-600">{{ expiredCount() }}</div>
                    }
                </div>
                <div class="flex align-items-center justify-content-center bg-red-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                    <i class="pi pi-times-circle text-red-600 text-xl" style="line-height: 0"></i>
                </div>
            </div>
            <div class="flex align-items-center justify-content-between">
                <span class="text-red-500 font-medium text-xs">No aptos para uso (Baja)</span>
                <i class="pi pi-info-circle text-400 text-xs cursor-pointer" pTooltip="Lotes o reactivos cuya fecha de expiración ya caducó. Deben ser retirados de uso inmediatamente." tooltipPosition="top"></i>
            </div>
        </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
        <div class="surface-card shadow-2 p-3 border-round cursor-pointer hover:surface-100 transition-all transition-duration-200"
             [class.border-left-3]="activeTab() === 1" [class.border-yellow-500]="activeTab() === 1"
             (click)="selectTab(1)">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-500 font-medium mb-2">Vencen en 30 días</span>
                    @if (loadingItems()) {
                        <p-skeleton width="3rem" height="2rem" />
                    } @else {
                        <div class="text-900 font-bold text-yellow-600 text-2xl">{{ expiringSoonCount() }}</div>
                    }
                </div>
                <div class="flex align-items-center justify-content-center bg-yellow-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                    <i class="pi pi-calendar-times text-yellow-600 text-xl" style="line-height: 0"></i>
                </div>
            </div>
            <div class="flex align-items-center justify-content-between">
                <span class="text-yellow-600 font-medium text-xs">Prioridad de consumo (FEFO)</span>
                <i class="pi pi-info-circle text-400 text-xs cursor-pointer" pTooltip="Material que caducará en los próximos 30 días. Priorizar su utilización según política FEFO." tooltipPosition="top"></i>
            </div>
        </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
        <div class="surface-card shadow-2 p-3 border-round cursor-pointer hover:surface-100 transition-all transition-duration-200" 
             (click)="selectTab(4)">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-500 font-medium mb-2">Exceso de Stock</span>
                    @if (loadingItems()) {
                        <p-skeleton width="3rem" height="2rem" />
                    } @else {
                        <div class="text-900 font-bold text-2xl text-purple-600">{{ highStock() }}</div>
                    }
                </div>
                <div class="flex align-items-center justify-content-center bg-purple-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                    <i class="pi pi-arrow-up-right text-purple-500 text-xl" style="line-height: 0"></i>
                </div>
            </div>
            <div class="flex align-items-center justify-content-between">
                <span class="text-purple-500 font-medium text-xs">Stock &gt; Punto Máximo</span>
                <i class="pi pi-info-circle text-400 text-xs cursor-pointer" pTooltip="Artículos que superan el límite máximo establecido (Stock > Máximo). Representa sobrestock e inmovilización." tooltipPosition="top"></i>
            </div>
        </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
        <div class="surface-card shadow-2 p-3 border-round">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-500 font-medium mb-2">Autonomía (Cobertura)</span>
                    @if (loadingMovements()) {
                        <p-skeleton width="4rem" height="2rem" />
                    } @else {
                        <div class="text-900 font-bold text-2xl">{{ coverageTitle() }}</div>
                    }
                </div>
                <div class="flex align-items-center justify-content-center bg-teal-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                    <i class="pi pi-clock text-teal-600 text-xl" style="line-height: 0"></i>
                </div>
            </div>
            <div class="flex align-items-center justify-content-between">
                <span class="text-teal-600 font-medium text-xs">{{ coverageSublabel() }}</span>
                <i class="pi pi-info-circle text-400 text-xs cursor-pointer" pTooltip="Días estimados de operación con el stock actual según el consumo diario promedio de los últimos 30 días (Stock Total / Consumo Diario)." tooltipPosition="top"></i>
            </div>
        </div>
    </div>

    <!-- KPIs Row 3 (Health Analysis) -->
    <div class="col-12 md:col-6 lg:col-6">
        <div class="surface-card shadow-2 p-3 border-round cursor-pointer hover:surface-100 transition-all transition-duration-200"
             [class.border-left-3]="activeTab() === 5" [class.border-orange-500]="activeTab() === 5"
             (click)="selectTab(5)">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-500 font-medium mb-2">Consumo Anómalo</span>
                    @if (loadingItems()) {
                        <p-skeleton width="3rem" height="2rem" />
                    } @else {
                        <div class="text-900 font-bold text-2xl text-orange-600">{{ anomalousCount() }}</div>
                    }
                </div>
                <div class="flex align-items-center justify-content-center bg-orange-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                    <i class="pi pi-chart-line text-orange-600 text-xl" style="line-height: 0"></i>
                </div>
            </div>
            <div class="flex align-items-center justify-content-between">
                <span class="text-orange-500 font-medium text-xs">Picos de uso detectados</span>
                <i class="pi pi-info-circle text-400 text-xs cursor-pointer" pTooltip="Artículos cuyo consumo mensual aumentó más del 100% respecto a su histórico. Amerita auditoría de uso." tooltipPosition="top"></i>
            </div>
        </div>
    </div>
    <div class="col-12 md:col-6 lg:col-6">
        <div class="surface-card shadow-2 p-3 border-round cursor-pointer hover:surface-100 transition-all transition-duration-200"
             [class.border-left-3]="activeTab() === 6" [class.border-indigo-500]="activeTab() === 6"
             (click)="selectTab(6)">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-500 font-medium mb-2">Stock Inmovilizado</span>
                    @if (loadingItems()) {
                        <p-skeleton width="3rem" height="2rem" />
                    } @else {
                        <div class="text-900 font-bold text-2xl text-indigo-600">{{ immobilizedCount() }}</div>
                    }
                </div>
                <div class="flex align-items-center justify-content-center bg-indigo-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                    <i class="pi pi-pause-circle text-indigo-600 text-xl" style="line-height: 0"></i>
                </div>
            </div>
            <div class="flex align-items-center justify-content-between">
                <span class="text-indigo-500 font-medium text-xs">Sin salidas en 90 días</span>
                <i class="pi pi-info-circle text-400 text-xs cursor-pointer" pTooltip="Artículos con stock disponible que no registran egresos en más de 3 meses. Riesgo de obsolescencia." tooltipPosition="top"></i>
            </div>
        </div>
    </div>

    <!-- Details Table Section -->
    <div class="col-12" id="inventory-detail-table">
        <div class="surface-card shadow-2 border-round p-4">
            <div class="text-xl font-bold text-900 mb-4 flex align-items-center gap-2">
                <i class="pi pi-list text-primary"></i>
                Detalle de Artículos en Alerta
            </div>
            
            @if (loadingItems()) {
                <div class="p-3">
                    <p-skeleton width="100%" height="2.5rem" styleClass="mb-3" />
                    <p-skeleton width="100%" height="12rem" />
                </div>
            } @else {
                <p-tabs [value]="activeTab()" (valueChange)="activeTab.set($event)">
                    <p-tablist>
                        <p-tab [value]="0">Stock Bajo ({{ lowStockItems().length }})</p-tab>
                        <p-tab [value]="1">Próx. Vencimientos ({{ expiringItems().length }})</p-tab>
                        <p-tab [value]="2">Vencidos ({{ expiredItems().length }})</p-tab>
                        <p-tab [value]="4">Exceso de Stock ({{ highStockItems().length }})</p-tab>
                        <p-tab [value]="5">Consumo Anómalo ({{ anomalousItems().length }})</p-tab>
                        <p-tab [value]="6">Inmovilizado ({{ immobilizedItems().length }})</p-tab>
                        <p-tab [value]="3">Top Movimiento ({{ topMovedItems().length }})</p-tab>
                    </p-tablist>
                    
                    <p-tabpanels>
                        <p-tabpanel [value]="0">
                            <p-table [value]="lowStockItems()" responsiveLayout="scroll" [rows]="5" [paginator]="true" class="p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Código</th>
                                        <th>Nombre</th>
                                        <th>Stock Actual</th>
                                        <th>Mínimo</th>
                                        <th>Estado</th>
                                        <th style="width: 4rem"></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            <a class="font-bold text-primary cursor-pointer hover:underline" (click)="goToItem(item.id || item._id)">
                                                {{ item.internal_code }}
                                            </a>
                                        </td>
                                        <td>{{ item.name }}</td>
                                        <td class="text-red-600 font-bold">{{ item.stock }}</td>
                                        <td>{{ item.min_stock }}</td>
                                        <td><p-tag severity="danger" value="CRÍTICO"></p-tag></td>
                                        <td class="text-center">
                                            <button pButton icon="pi pi-external-link" class="p-button-text p-button-rounded p-button-sm" pTooltip="Ver Hoja de Vida" tooltipPosition="left" (click)="goToItem(item.id || item._id)"></button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="6" class="text-center py-5 text-500">
                                            <div class="flex flex-column align-items-center gap-2">
                                                <i class="pi pi-check-circle text-green-500 text-3xl"></i>
                                                <span class="font-medium text-700">Sin artículos con stock crítico</span>
                                                <span class="text-xs text-500">Todos los artículos del catálogo superan el punto mínimo de seguridad.</span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabpanel>
                        <p-tabpanel [value]="1">
                            <p-table [value]="expiringItems()" responsiveLayout="scroll" [rows]="5" [paginator]="true" class="p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Código</th>
                                        <th>Nombre</th>
                                        <th>Vencimiento</th>
                                        <th>Stock</th>
                                        <th>Estado</th>
                                        <th style="width: 4rem"></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            <a class="font-bold text-primary cursor-pointer hover:underline" (click)="goToItem(item.id || item._id)">
                                                {{ item.internal_code }}
                                            </a>
                                        </td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.expiration_date | date:'dd/MM/yyyy' }}</td>
                                        <td>{{ item.stock }}</td>
                                        <td><p-tag severity="warn" value="PRÓXIMO"></p-tag></td>
                                        <td class="text-center">
                                            <button pButton icon="pi pi-external-link" class="p-button-text p-button-rounded p-button-sm" pTooltip="Ver Hoja de Vida" tooltipPosition="left" (click)="goToItem(item.id || item._id)"></button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="6" class="text-center py-5 text-500">
                                            <div class="flex flex-column align-items-center gap-2">
                                                <i class="pi pi-calendar-check text-yellow-600 text-3xl"></i>
                                                <span class="font-medium text-700">Sin vencimientos en los próximos 30 días</span>
                                                <span class="text-xs text-500">No hay lotes con fecha de caducidad cercana.</span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabpanel>
                        <p-tabpanel [value]="2">
                            <p-table [value]="expiredItems()" responsiveLayout="scroll" [rows]="5" [paginator]="true" class="p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Código</th>
                                        <th>Nombre</th>
                                        <th>Vencimiento</th>
                                        <th>Stock</th>
                                        <th>Estado</th>
                                        <th style="width: 4rem"></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            <a class="font-bold text-primary cursor-pointer hover:underline" (click)="goToItem(item.id || item._id)">
                                                {{ item.internal_code }}
                                            </a>
                                        </td>
                                        <td>{{ item.name }}</td>
                                        <td class="text-red-600">{{ item.expiration_date | date:'dd/MM/yyyy' }}</td>
                                        <td>{{ item.stock }}</td>
                                        <td><p-tag severity="danger" value="VENCIDO"></p-tag></td>
                                        <td class="text-center">
                                            <button pButton icon="pi pi-external-link" class="p-button-text p-button-rounded p-button-sm" pTooltip="Ver Hoja de Vida" tooltipPosition="left" (click)="goToItem(item.id || item._id)"></button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="6" class="text-center py-5 text-500">
                                            <div class="flex flex-column align-items-center gap-2">
                                                <i class="pi pi-check-circle text-green-500 text-3xl"></i>
                                                <span class="font-medium text-700">Sin artículos vencidos</span>
                                                <span class="text-xs text-500">Todo el inventario activo se encuentra dentro de su periodo de vigencia.</span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabpanel>
                        <p-tabpanel [value]="4">
                            <p-table [value]="highStockItems()" responsiveLayout="scroll" [rows]="5" [paginator]="true" class="p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Código</th>
                                        <th>Nombre</th>
                                        <th>Stock Actual</th>
                                        <th>Máximo</th>
                                        <th>Estado</th>
                                        <th style="width: 4rem"></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            <a class="font-bold text-primary cursor-pointer hover:underline" (click)="goToItem(item.id || item._id)">
                                                {{ item.internal_code }}
                                            </a>
                                        </td>
                                        <td>{{ item.name }}</td>
                                        <td class="text-purple-600 font-bold">{{ item.stock }}</td>
                                        <td>{{ item.max_stock }}</td>
                                        <td><p-tag severity="secondary" value="SOBRESTOCK"></p-tag></td>
                                        <td class="text-center">
                                            <button pButton icon="pi pi-external-link" class="p-button-text p-button-rounded p-button-sm" pTooltip="Ver Hoja de Vida" tooltipPosition="left" (click)="goToItem(item.id || item._id)"></button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="6" class="text-center py-5 text-500">
                                            <div class="flex flex-column align-items-center gap-2">
                                                <i class="pi pi-check-circle text-green-500 text-3xl"></i>
                                                <span class="font-medium text-700">Sin exceso de stock</span>
                                                <span class="text-xs text-500">Ningún artículo supera el nivel máximo de almacenamiento definido.</span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabpanel>
                        <p-tabpanel [value]="5">
                            <p-table [value]="anomalousItems()" responsiveLayout="scroll" [rows]="5" [paginator]="true" class="p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Código</th>
                                        <th>Nombre</th>
                                        <th>Stock</th>
                                        <th>Estado</th>
                                        <th style="width: 4rem"></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            <a class="font-bold text-primary cursor-pointer hover:underline" (click)="goToItem(item.id || item._id)">
                                                {{ item.internal_code }}
                                            </a>
                                        </td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.stock }}</td>
                                        <td><p-tag severity="warning" value="PICO DE USO"></p-tag></td>
                                        <td class="text-center">
                                            <button pButton icon="pi pi-external-link" class="p-button-text p-button-rounded p-button-sm" pTooltip="Ver Hoja de Vida" tooltipPosition="left" (click)="goToItem(item.id || item._id)"></button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="5" class="text-center py-5 text-500">
                                            <div class="flex flex-column align-items-center gap-2">
                                                <i class="pi pi-check-circle text-green-500 text-3xl"></i>
                                                <span class="font-medium text-700">Consumo estable</span>
                                                <span class="text-xs text-500">No se detectaron incrementos anómalos superiores al 100% en el consumo mensual.</span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabpanel>
                        <p-tabpanel [value]="6">
                            <p-table [value]="immobilizedItems()" responsiveLayout="scroll" [rows]="5" [paginator]="true" class="p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Código</th>
                                        <th>Nombre</th>
                                        <th>Stock</th>
                                        <th>Últ. Salida</th>
                                        <th>Estado</th>
                                        <th style="width: 4rem"></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            <a class="font-bold text-primary cursor-pointer hover:underline" (click)="goToItem(item.id || item._id)">
                                                {{ item.internal_code }}
                                            </a>
                                        </td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.stock }}</td>
                                        <td>> 90 días</td>
                                        <td><p-tag severity="info" value="INMOVILIZADO"></p-tag></td>
                                        <td class="text-center">
                                            <button pButton icon="pi pi-external-link" class="p-button-text p-button-rounded p-button-sm" pTooltip="Ver Hoja de Vida" tooltipPosition="left" (click)="goToItem(item.id || item._id)"></button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="6" class="text-center py-5 text-500">
                                            <div class="flex flex-column align-items-center gap-2">
                                                <i class="pi pi-check-circle text-green-500 text-3xl"></i>
                                                <span class="font-medium text-700">Sin stock inmovilizado</span>
                                                <span class="text-xs text-500">Todos los artículos con stock han registrado movimientos en los últimos 90 días.</span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabpanel>
                        <p-tabpanel [value]="3">
                            <p-table [value]="topMovedItems()" responsiveLayout="scroll" [rows]="5" [paginator]="true" class="p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Código</th>
                                        <th>Nombre</th>
                                        <th>Cant. Movida</th>
                                        <th style="width: 4rem"></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-product>
                                    <tr>
                                        <td>
                                            <a class="font-bold text-primary cursor-pointer hover:underline" (click)="goToItem(product.id || product.item_id || product._id)">
                                                {{ product.code }}
                                            </a>
                                        </td>
                                        <td>{{ product.name }}</td>
                                        <td class="font-bold">{{ product.total_quantity }}</td>
                                        <td class="text-center">
                                            <button pButton icon="pi pi-external-link" class="p-button-text p-button-rounded p-button-sm" pTooltip="Ver Hoja de Vida" tooltipPosition="left" (click)="goToItem(product.id || product.item_id || product._id)"></button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="4" class="text-center py-5 text-500">
                                            <div class="flex flex-column align-items-center gap-2">
                                                <i class="pi pi-arrows-alt text-400 text-3xl"></i>
                                                <span class="font-medium text-700">Sin operaciones registradas</span>
                                                <span class="text-xs text-500">No se registran movimientos para rankear los artículos con mayor rotación.</span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabpanel>
                    </p-tabpanels>
                </p-tabs>
            }
        </div>
    </div>

    <!-- Strategic Trend Chart -->
    <div class="col-12">
        <div class="surface-card shadow-2 border-round p-4 mb-4">
            <div class="mb-4">
                <div class="flex align-items-center justify-content-between flex-wrap gap-2">
                    <div>
                        <div class="text-xl font-bold text-900">Evolución de Inversión en Stock (6 meses)</div>
                        <div class="text-500 text-sm mt-1">Valorización estimada al cierre de cada mes según movimientos valorizados</div>
                    </div>
                    <div class="flex align-items-center gap-3">
                        @if (availableCurrencies().length > 1) {
                            <div class="flex gap-1 surface-100 p-1 border-round">
                                @for (curr of availableCurrencies(); track curr) {
                                    <button pButton type="button" 
                                            class="p-button-sm text-xs font-bold px-3 py-1 border-round"
                                            [class.p-button-primary]="selectedHistoricalCurrency() === curr"
                                            [class.p-button-text]="selectedHistoricalCurrency() !== curr"
                                            [class.text-700]="selectedHistoricalCurrency() !== curr"
                                            [label]="curr"
                                            (click)="setHistoricalCurrency(curr)">
                                    </button>
                                }
                            </div>
                        }
                        <i class="pi pi-chart-line text-blue-500 text-2xl"></i>
                    </div>
                </div>
            </div>
            @if (loadingMovements()) {
                <p-skeleton width="100%" height="300px" />
            } @else if (hasHistoricalData()) {
                <p-chart type="line" [data]="historicalValueData()" [options]="historicalValueOptions()" height="300px"></p-chart>
            } @else {
                <div class="flex flex-column align-items-center justify-content-center py-7 text-500">
                    <div class="flex align-items-center justify-content-center bg-blue-50 border-circle mb-3" style="width: 3.5rem; height: 3.5rem;">
                        <i class="pi pi-chart-line text-blue-500 text-2xl"></i>
                    </div>
                    <span class="font-semibold text-700 text-base mb-1">Sin histórico de valorización ({{ selectedHistoricalCurrency() }})</span>
                    <span class="text-sm text-500 text-center" style="max-width: 360px;">No se registran variaciones de stock valorizadas en {{ selectedHistoricalCurrency() }} en los últimos 6 meses para proyectar la curva evolutiva.</span>
                </div>
            }
        </div>
    </div>

    <!-- Charts Row 1 -->
    <div class="col-12 lg:col-6">
        <div class="surface-card shadow-2 border-round p-4 h-full">
            <div class="mb-3">
                <div class="text-xl font-medium text-900">Movimientos de Stock (30 días)</div>
                <div class="text-500 text-sm mt-1">Total de operaciones de Entrada, Salida y Ajuste registradas</div>
            </div>
            @if (loadingMovements()) {
                <p-skeleton width="100%" height="300px" />
            } @else if (hasMovementsData()) {
                <p-chart type="bar" [data]="movementsData()" [options]="movementsOptions()" height="300px"></p-chart>
            } @else {
                <div class="flex flex-column align-items-center justify-content-center py-7 text-500">
                    <div class="flex align-items-center justify-content-center bg-gray-100 border-circle mb-3" style="width: 3.5rem; height: 3.5rem;">
                        <i class="pi pi-arrows-alt text-400 text-2xl"></i>
                    </div>
                    <span class="font-semibold text-700 text-base mb-1">Sin movimientos en los últimos 30 días</span>
                    <span class="text-sm text-500 text-center" style="max-width: 320px;">Las entradas, salidas y ajustes de inventario registrados en el periodo aparecerán aquí automáticamente.</span>
                </div>
            }
        </div>
    </div>

    <div class="col-12 lg:col-6">
        <div class="surface-card shadow-2 border-round p-4 h-full">
            <div class="mb-3">
                <div class="text-xl font-medium text-900">Distribución por Tipo de Artículo</div>
                <div class="text-500 text-sm mt-1">Cantidad de artículos clasificados por categoría</div>
            </div>
            @if (loadingItems()) {
                <div class="flex justify-content-center"><p-skeleton size="300px" shape="circle" /></div>
            } @else if (hasItemsByTypeData()) {
                <div class="flex justify-content-center">
                    <p-chart type="pie" [data]="itemsByTypeData()" [options]="itemsByTypeOptions()" height="300px"></p-chart>
                </div>
            } @else {
                <div class="flex flex-column align-items-center justify-content-center py-7 text-500">
                    <div class="flex align-items-center justify-content-center bg-gray-100 border-circle mb-3" style="width: 3.5rem; height: 3.5rem;">
                        <i class="pi pi-chart-pie text-400 text-2xl"></i>
                    </div>
                    <span class="font-semibold text-700 text-base mb-1">Sin artículos categorizados</span>
                    <span class="text-sm text-500 text-center" style="max-width: 300px;">No se encontraron artículos registrados para mostrar su distribución.</span>
                </div>
            }
        </div>
    </div>

    <!-- Charts Row 2 -->
    <div class="col-12 lg:col-6">
        <div class="surface-card shadow-2 border-round p-4 h-full">
            <div class="mb-3">
                <div class="text-xl font-medium text-900">Desglose de Mermas y Ajustes</div>
                <div class="text-500 text-sm mt-1">Distribución de motivos en operaciones de ajuste</div>
            </div>
            @if (loadingMovements()) {
                <p-skeleton width="100%" height="300px" />
            } @else if (adjustmentsData()?.labels?.length > 0) {
                <div class="flex justify-content-center">
                    <p-chart type="doughnut" [data]="adjustmentsData()" [options]="adjustmentsOptions()" height="300px"></p-chart>
                </div>
            } @else {
                <div class="flex flex-column align-items-center justify-content-center py-7 text-500">
                    <div class="flex align-items-center justify-content-center bg-green-50 border-circle mb-3" style="width: 3.5rem; height: 3.5rem;">
                        <i class="pi pi-check-circle text-green-500 text-2xl"></i>
                    </div>
                    <span class="font-semibold text-700 text-base mb-1">Sin mermas ni ajustes</span>
                    <span class="text-sm text-500 text-center" style="max-width: 300px;">No se registraron ajustes por diferencias ni mermas en este periodo.</span>
                </div>
            }
        </div>
    </div>

    <div class="col-12 lg:col-6">
        <div class="surface-card shadow-2 border-round p-4 h-full">
            <div class="mb-3">
                <div class="flex align-items-center justify-content-between flex-wrap gap-2">
                    <div>
                        <div class="text-xl font-medium text-900">Valor de Stock por Clase</div>
                        <div class="text-500 text-sm mt-1">Capital inmovilizado según tipo de material</div>
                    </div>
                    @if (availableCurrencies().length > 1) {
                        <div class="flex gap-1 surface-100 p-1 border-round">
                            @for (curr of availableCurrencies(); track curr) {
                                <button pButton type="button" 
                                        class="p-button-sm text-xs font-bold px-3 py-1 border-round"
                                        [class.p-button-primary]="selectedValuedStockCurrency() === curr"
                                        [class.p-button-text]="selectedValuedStockCurrency() !== curr"
                                        [class.text-700]="selectedValuedStockCurrency() !== curr"
                                        [label]="curr"
                                        (click)="setValuedStockCurrency(curr)">
                                </button>
                            }
                        </div>
                    }
                </div>
            </div>
            @if (loadingItems()) {
                <p-skeleton width="100%" height="300px" />
            } @else if (hasValuedStockData()) {
                <p-chart type="bar" [data]="valuedStockByTypeData()" [options]="valuedStockByTypeOptions()" height="300px"></p-chart>
            } @else {
                <div class="flex flex-column align-items-center justify-content-center py-7 text-500">
                    <div class="flex align-items-center justify-content-center bg-gray-100 border-circle mb-3" style="width: 3.5rem; height: 3.5rem;">
                        <i class="pi pi-wallet text-400 text-2xl"></i>
                    </div>
                    <span class="font-semibold text-700 text-base mb-1">Sin valorización en {{ selectedValuedStockCurrency() }}</span>
                    <span class="text-sm text-500 text-center" style="max-width: 300px;">No hay existencias con precio unitario en {{ selectedValuedStockCurrency() }} configurado para calcular el valor por tipo.</span>
                </div>
            }
        </div>
    </div>
</div>
